// extracted by mini-css-extract-plugin
export var closeButton = "_hx-2";
export var closeButtonIcon = "_hx-3";
export var lightboxContent = "_hx-1";
export var lightboxOverlay = "_hx-0";